export default class WorkPlanHoursOfDedicatedViewCtrl {

  constructor ($scope, WorkPlanParametrizationSrv, $stateParams, $mdDialog, GlobalConfig) {
    const hoursOfDedicationVM = this
    hoursOfDedicationVM.workplanHours = []
    hoursOfDedicationVM.workplan = {}
    hoursOfDedicationVM.saveWorkplanHoursOfDedicated = saveWorkplanHoursOfDedicated
    hoursOfDedicationVM.validateForm = validateForm
    hoursOfDedicationVM.hasError = hasError
    hoursOfDedicationVM.showErrorMessages = showErrorMessages
    hoursOfDedicationVM.getFormAttribute = getFormAttribute
    hoursOfDedicationVM.hoursControlChange = hoursControlChange
    hoursOfDedicationVM.isDisabledInput = isDisabledInput
    hoursOfDedicationVM.countWorkplanHours = 0;

  // SERVICES
    function activate () {
      return hoursOfDedicated().then(getWorkPlanHeader())
    }

    function hoursOfDedicated () {
      return WorkPlanParametrizationSrv.hoursOfDedicated.get({workplanId: $stateParams.id}).$promise.then((dataReturn) => {
        if (dataReturn.status === true) {
          hoursOfDedicationVM.workplanHours = dataReturn.values
          hoursOfDedicationVM.countWorkplanHours = hoursOfDedicationVM.workplanHours.length;
        }
      })
    }

    function getWorkPlanHeader () {
      return WorkPlanParametrizationSrv.getWorkPlanHeader.get({workplanId: $stateParams.id}).$promise.then((dataReturn) => {
        if (dataReturn.status === true) {
          hoursOfDedicationVM.workplan = dataReturn.data
          hoursOfDedicationVM.workplan.id_code = $stateParams.id
          hoursOfDedicationVM.hoursControlChange()
        }
      })
    }

  // METHOD DEFINITIONS
    function saveWorkplanHoursOfDedicated () {
      let post = {
        id_work_plan: $stateParams.id,
        is_control_hours_active: hoursOfDedicationVM.workplan.is_control_hours_active,
        values: hoursOfDedicationVM.workplanHours
      }

      WorkPlanParametrizationSrv.addWorkplanHoursOfDedicated.add(post).$promise.then((dataReturn) => {
        if (dataReturn.status === true) {
            // todo manage to show popup
          showModalHoursSetedUp()
        }
      })
    }

    function showModalHoursSetedUp () {
      let planName = hoursOfDedicationVM.workplan.plan_name
      $mdDialog.show({
        controller: ['$scope', '$mdDialog', function ($scope, $mdDialog) {
          $scope.planName = planName
          $scope.close = function () {
            $mdDialog.hide()
          }
        }],
        template: require('./modalHoursSetedUp.html'),
        clickOutsideToClose: false
      })
    };

    function validateForm (form) {
      return form.$invalid
    }

    function hasError (input) {
      if (input.$invalid && (input.$dirty || input.$touched)) {
        return 'has-error'
      }
    }

    function showErrorMessages (input) {
      return input.$dirty || input.$touched
    }

    function getFormAttribute (form, attr, index) {
      attr = attr + index
      return form[attr]
    }

    function hoursControlChange () {
      hoursOfDedicationVM.hoursControlLabel = 'Control de horas '
      hoursOfDedicationVM.hoursControlLabel += (hoursOfDedicationVM.workplan.is_control_hours_active === 1) ? 'activado' : 'desactivado'
    }

    function isDisabledInput(pid){
      if(pid == GlobalConfig.notAloweedHours.idDocenteCatedra){
        return true;
      }
      return false;
    }

  // INITIALIZE
    activate()
  }
}

WorkPlanHoursOfDedicatedViewCtrl.$inject = ['$scope', 'WorkPlanParametrizationSrv', '$stateParams', '$mdDialog', 'GlobalConfig']



// WEBPACK FOOTER //
// ./src/app/u-faculty/workPlanParametrization/create/workPlanHoursOfDedicatedViewCtrl.js